export const isNodeInsideDrawer = (target: EventTarget | null, drawerElement: HTMLElement | null): boolean => {
  if (!(target instanceof Node) || !drawerElement) {
    return false
  }

  return drawerElement.contains(target)
}
